import React, { useState, useEffect } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import Container from 'react-bootstrap/Container';
import { useParams } from 'react-router-dom';
import FlickrGallery from './FlickrGallery';

const Events = () => {
  const { currentTab } = useParams();
  const [activeTabIndex, setActiveTabIndex] = useState();

  const tabs = ['', 'pictures'];

  useEffect(() => {
    setActiveTabIndex(
      !currentTab ? 0 : tabs.findIndex((el) => el === currentTab)
    );
  }, [currentTab]);

  const handleTabChange = (newTabIndex) => {
    setActiveTabIndex(newTabIndex);
    if (newTabIndex === 0) {
      window.history.replaceState(null, null, '/events');
    } else {
      window.history.replaceState(null, null, `/events/${tabs[newTabIndex]}`);
    }
  };

  return (
    <>
      <div className='page-header text-center d-flex container-fluid justify-content-center align-items-center'>
        <h1>Events</h1>
      </div>
      <TabView
        className='mt-1 nav-ribbon'
        activeIndex={activeTabIndex}
        onTabChange={(e) => handleTabChange(e.index)}
        scrollable
      >
        <TabPanel header='Events'>
          <Container>
            <iframe
              src="https://youngisrael-stl.easyshul.com/events-calendar"
              width="100%"
              height="700px"
              frameBorder="0"
              title="Events"
            />
          </Container>
        </TabPanel>
        <TabPanel header="Pictures">
          <Container>
            <FlickrGallery />
          </Container>
        </TabPanel>
      </TabView>
    </>
  );
};

export default Events;
